import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function FavoriteIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 16.719}
      height={height || 16.002}
      viewBox="0 0 16.719 16.002"
    >
      <path
        data-name="Favorite"
        d="M16.5-8.641l-4.566-.666L9.9-13.444a1 1 0 00-1.794 0L6.062-9.306 1.5-8.641a1 1 0 00-.556 1.707l3.3 3.219L3.466.831a1 1 0 001.45 1.053L9-.263l4.084 2.147a1 1 0 001.45-1.053l-.781-4.547 3.3-3.219a1 1 0 00-.553-1.706zm-4.359 4.4l.743 4.325L9-1.956 5.116.084l.741-4.325L2.712-7.3l4.344-.631L9-11.872l1.944 3.937 4.344.631z"
        transform="translate(-160.521 -104) translate(159.881 118)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
